import { useMemo } from 'react';
import { useLocation } from 'react-router';
export default function useQueryParams() {
    const location = useLocation();
    return useMemo(() => Array.from(new URLSearchParams(location.search).entries())
        .reduce((a, [key, value]) => (Object.assign(Object.assign({}, a), { [key]: value })), {}), [location.search]);
}
